
const apiConfig = {
    //Local
    //apiUrl: 'https://localhost:7205/api/',
    //Live
    apiUrl: 'https://sv-api.solegaze.com/api/',
    apiKey: 'Lieda1002',
};
export default apiConfig;

